import { ActionTree, GetterTree, MutationTree } from "vuex";
import { FirebaseModuleType, PromotionLabelType } from "@/types/FirebaseTypes";
import firebase from "firebase/app";
import "firebase/analytics";
import "firebase/remote-config";
import { firebaseEnvironmentKey } from "@/utils/FirebaseKeys";

const firebaseConfig = {
  apiKey: String(process.env.VUE_APP_FIREABSE_API_KEY),
  authDomain: String(process.env.VUE_APP_FIRAEBASE_AUTH_DOMAIN),
  databaseURL: String(process.env.VUE_APP_FIREBASE_DATABASE_URL),
  projectId: String(process.env.VUE_APP_FIREBASE_PROJECT_ID),
  storageBucket: String(process.env.VUE_APP_FIREBASE_STORAGE_BUCKET),
  messagingSenderId: String(process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID),
  appId: String(process.env.VUE_APP_FIREBASE_APP_ID),
  measurementId: String(process.env.VUE_APP_FIREBASE_MEASUREMENT_ID),
};

const state: FirebaseModuleType = {
  isPortalOff: false,
  showWhatsapp: true,
  showPortability: true,
  showChat: true,
  showChatButton: true,
  showWebview: true,
  catalogPlans: [
    "1f8faf07-4541-43b5-b95a-a1560f7e34bc",
    "0d8fa42d-6d8e-4da9-a68a-b51e947a4b98",
    "ee9b746e-aff5-44d4-bdf2-ed9565687b99",
    "590b42f9-02cd-4269-b9d3-d35c4a7c0e5c",
    "e6647dbe-b7df-4dd4-8323-7ad638c10ca6",
    "03b560ac-ff5d-485f-8a86-8665b859a98b",
  ],
  slidesPerView: "3.2",
  urlChat: "https://chatclaroflex.ilinksolutions.com.br/webchatinit/init",
  promotionLabel: {
    active: true,
    plans: [
      {
        id: "590b42f9-02cd-4269-b9d3-d35c4a7c0e5c",
        label: "Oferta da Semana",
      },
    ],
  },
  flowCollaboratorActive: false,
  vertexParams: {
    url: "https://meuplanoclaro.com.br/flex?utm_source=portal_flex",
    active: true,
    message: "",
  },
  isShowSimDelivery: true,
  idOrigin: {
    id: ["utm_campaign", "gclid"],
    origin: "utm_source",
  },
  bonusValue: "10GB de bônus",
  meli: [],
  isMeli: false,
  notEditCoupon: [],
};

const getters: GetterTree<FirebaseModuleType, any> = {
  getIsPortalOff: (state) => state.isPortalOff,
  getShowWhatsapp: (state) => state.showWhatsapp,
  getShowPortability: (state) => state.showPortability,
  getShowChat: (state) => state.showChat,
  getShowChatButton: (state) => state.showChatButton,
  getShowWebview: (state) => state.showWebview,
  getCatalogPlans: (state) => state.catalogPlans,
  getSlidesPerView: (state) => state.slidesPerView,
  getUrlChat: (state) => state.urlChat,
  getPromotionLabel: (state) => state.promotionLabel,
  getFlowCollaboratorActive: (state) => state.flowCollaboratorActive,
  getVertexParams: (state) => state.vertexParams,
  getIsShowSimDelivery: (state) => state.isShowSimDelivery,
  getIdOrigin: (state) => state.idOrigin,
  getBonusValue: (state) => state.bonusValue,
  getMeli: (state) => state.meli,
  getIsMeli: (state) => state.isMeli,
  getNotEditCoupon: (state) => state.notEditCoupon,
};

const mutations: MutationTree<FirebaseModuleType> = {
  setIsPortalOff(state, payload: boolean) {
    state.isPortalOff = payload;
  },
  setShowWhatsapp(state, payload: boolean) {
    state.showWhatsapp = payload;
  },
  setShowPortability(state, payload: boolean) {
    state.showPortability = payload;
  },
  setShowChat(state, payload: boolean) {
    state.showChat = payload;
  },
  setShowChatButton(state, payload: boolean) {
    state.showChatButton = payload;
  },
  setShowWebview(state, payload: boolean) {
    state.showWebview = payload;
  },
  setCatalogPlans(state, payload: string[]) {
    state.catalogPlans = payload;
  },
  setSlidesPerView(state, payload: string) {
    state.slidesPerView = payload;
  },
  setUrlChat(state, payload: string) {
    state.urlChat = payload;
  },
  setPromotionLabel(state, payload: PromotionLabelType) {
    state.promotionLabel = payload;
  },
  setFlowCollaboratorActive(state, payload: boolean) {
    state.flowCollaboratorActive = payload;
  },
  setVertexParams(state, payload: any) {
    state.vertexParams = payload;
  },
  setIsShowSimDelivery(state, payload: boolean) {
    state.isShowSimDelivery = payload;
  },
  setIdOrigin(state, payload: any) {
    state.idOrigin = payload;
  },
  setBonusValue(state, payload: string) {
    state.bonusValue = payload;
  },
  setMeli(state, payload: string[]) {
    state.meli = payload;
  },
  setIsMeli(state, payload: boolean) {
    state.isMeli = payload;
  },
  setNotEditCoupon(state, payload: string[]) {
    state.notEditCoupon = payload;
  },
};

const actions: ActionTree<FirebaseModuleType, any> = {
  async getFirebaseConfig({ commit }): Promise<void> {
    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
      firebase.analytics();
    }

    const remoteConfig = firebase.remoteConfig();
    remoteConfig.settings.minimumFetchIntervalMillis = 10000;
    remoteConfig.defaultConfig = {
      QA_IsPortalOff: false,
    };

    await remoteConfig.fetchAndActivate();

    const firebaseKey = await firebaseEnvironmentKey("portal_config");

    const getFirebase = await remoteConfig.getString(firebaseKey);

    if (getFirebase) {
      const {
        catalogPlans,
        flowCollaboratorActive,
        idOrigin,
        isPortalOff,
        isShowSimDelivery,
        promotionLabel,
        showChat,
        showButtonChat,
        showPortability,
        showWebView,
        showWhatsapp,
        slidesPerView,
        urlChat,
        vertexParams,
        bonusValue,
        meli,
        notEditCoupon,
      } = await JSON.parse(getFirebase);

      commit("setPromotionLabel", promotionLabel);
      commit("setCatalogPlans", catalogPlans.split("|"));
      commit("setFlowCollaboratorActive", flowCollaboratorActive);
      commit("setIdOrigin", idOrigin);
      commit("setIsPortalOff", isPortalOff);
      commit("setIsShowSimDelivery", isShowSimDelivery);
      commit("setShowChat", showChat);
      commit("setShowChatButton", showButtonChat);
      commit("setShowPortability", showPortability);
      commit("setShowWebview", showWebView);
      commit("setShowWhatsapp", showWhatsapp);
      commit("setSlidesPerView", slidesPerView);
      commit("setUrlChat", urlChat);
      commit("setVertexParams", vertexParams);
      commit("setBonusValue", bonusValue);
      commit("setMeli", meli);
      commit("setNotEditCoupon", notEditCoupon);
    }
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
